import { httpClient } from "../core/api/client";

export interface UserApiKey {
  type: "CLEMENTINO" | "PASSENGER" | "YANGZI";
  configured: boolean;
  maskedKey?: string;
  updatedAt?: string;
}

export interface MyApiKeysResponse {
  clementino: boolean;
  passenger: boolean;
  yangzi: boolean;
  keys?: UserApiKey[];
}

export async function fetchMyApiKeys(): Promise<MyApiKeysResponse> {
  try {
    const res = await httpClient.get("/users/me/api-keys");
    const data = res.data || res;
    return {
      clementino: Boolean(data?.CLEMENTINO || data?.clementino),
      passenger: Boolean(data?.PASSENGER || data?.passenger),
      yangzi: Boolean(data?.YANGZI || data?.yangzi),
      keys: Array.isArray(data?.keys) ? data.keys : [],
    };
  } catch (error) {
    console.error("Erreur lors de la recuperation des cles API de l'utilisateur:", error);
    return {
      clementino: false,
      passenger: false,
      yangzi: false,
      keys: [],
    };
  }
}

export async function setUserApiKey(
  userId: number | string,
  apiKeyType: "CLEMENTINO" | "PASSENGER" | "YANGZI",
  apiKey: string
): Promise<boolean> {
  await httpClient.put(`/users/${userId}/api-keys/${apiKeyType}`, {
    apiKey,
  });
  return true;
}

export async function deleteUserApiKey(
  userId: number | string,
  apiKeyType: "CLEMENTINO" | "PASSENGER" | "YANGZI"
): Promise<boolean> {
  await httpClient.delete(`/users/${userId}/api-keys/${apiKeyType}`);
  return true;
}
